import { render, staticRenderFns } from "./IdentificationDetails.vue?vue&type=template&id=a58de052"
import script from "./IdentificationDetails.vue?vue&type=script&lang=js"
export * from "./IdentificationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports